import React from 'react';
import PropTypes from 'prop-types';
import IdleTimer from 'react-idle-timer';
import { withAuth } from '@okta/okta-react';
import { withRouter } from 'react-router-dom';
import { getPublicIp, handleLocalSearchInputStorage } from '../../containers/Utils';
import App from './app';

export const localStorageKey = 'wap-app-last-unloaded';
export const getLocalStorageTime = () => {
  const item = window.localStorage.getItem(localStorageKey);
  try {
    return JSON.parse(item);
  } catch (e) {
    // istanbul ignore next
    console.log('corrupt local storage time', item); // eslint-disable-line no-console
    // istanbul ignore next
    return 0;
  }
};

const REFRESH_PERIOD_MS = 7000;

export class AppWrapper extends React.Component {
  static propTypes = {
    auth: PropTypes.any.isRequired,
    location: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    const isImplicitCallback = props.location.search.indexOf('implicit/callback') !== -1;
    this.state = isImplicitCallback ? { authChecked: true } : {};
  }

  componentDidMount() {
    this._handleLoginLogout();
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.setTime);
  }

  setTime = () => {
    const now = Date.now();
    try {
      window.localStorage.setItem(localStorageKey, JSON.stringify(now));
    } catch (e) {
      // safari private browsing throws errors on setting local storage
      /* istanbul ignore next */
      console.log(`Storage Set Failed for key: ${localStorageKey}`, e); // eslint-disable-line no-console
    }
  }

  _handleLoginLogout = async () => {
    const now = Date.now();
    const lastUnload = getLocalStorageTime();
    if (!this.state.authChecked && (now - lastUnload) > REFRESH_PERIOD_MS) {
      // that means it is not a refresh and we need to logout.
      const authenticated = await this.props.auth.isAuthenticated();
      if (authenticated) {
        await this.props.auth.logout();
      }
    }
    window.addEventListener('beforeunload', this.setTime);
    if (!this.state.authChecked) {
      this.setState({ authChecked: true });
    }
    window.localStorage.setItem('publicIP', await getPublicIp());
  };

  render() {
    const { authChecked } = this.state;
    if (!authChecked) {
      return null;
    }
    const AppWithIdleTimer = () => (
      <IdleTimer
        ref={(ref) => { this.idleTimer = ref; }}
        element={document}
        onIdle={() => {
          handleLocalSearchInputStorage('remove', '');
          this.props.auth.logout();
        }}
        timeout={2000 * 60 * 60}
      >
        <App />
      </IdleTimer>
    );
    return <AppWithIdleTimer />;
  }
}

export default withAuth(withRouter(AppWrapper));



// WEBPACK FOOTER //
// ./src/app/containers/App/index.js